import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-expiration-dialog',
  templateUrl: './expiration-dialog.component.html',
  styleUrls: ['./expiration-dialog.component.scss']
})
export class ExpirationDialogComponent implements OnInit {
  countdown: number;

  constructor(
    public dialogRef: MatDialogRef<ExpirationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public authService: MsalService
  ) { }

  ngOnInit(): void {
    this.countdown = this.data.countdown;
    this.startCountdown();
  }

  onClose() {
    this.dialogRef.close();
  }

  startCountdown() {
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(interval);
        this.logoutAndClose();
      }
    }, 1000);
  }

  logoutAndClose() {
    this.dialogRef.close();
    this.authService.logout();
  }
}
